
import {
    GET_NUEVO_CLIENTE,
    GET_NUEVOS_CLIENTES,
    GET_NUEVOS_CLIENTES_ALL,
    GET_NUEVOS_CLIENTES_COUNT,
    ADD_NUEVO_CLIENTE,
    DELETE_NUEVO_CLIENTE,
    UPDATE_NUEVO_CLIENTE,
    GET_FILTROS_NUEVO_CLIENTE
} from "../action"

const initialState = {
    allData: [],
    data: [],
    total: 1,
    params: {},
    filtros: {}
}

const prefix = 'nuevosclientes'

const nuevosclientes = (state = initialState, action) => {
    switch (action.type) {
        case `${prefix}/GET_ALL_DATA`:
            return { ...state, allData: action.data }
        case GET_NUEVOS_CLIENTES:
            return {
                ...state,
                data: action.nuevosclientes,
                total: action.total || 0,
                params: action.params
            }
        case GET_NUEVOS_CLIENTES_ALL:
            return {
                ...state,
                nuevosclientes: action.nuevosclientes
            }
        case GET_NUEVO_CLIENTE:
            return { ...state, selectedNuevoCliente: action.selectedNuevoCliente, ultimoIdNuevoCliente: action.ultimoIdNuevoCliente }
        case ADD_NUEVO_CLIENTE:
            return { ...state, data: state.data.concat(action.data) }
        case DELETE_NUEVO_CLIENTE:
            return { ...state, data: [...state.data].filter(nuevocliente => nuevocliente.id !== action.data) }
        case GET_NUEVOS_CLIENTES_COUNT:
            return { ...state, total: action.total }
        case UPDATE_NUEVO_CLIENTE:
            return { ...state, data: state.data.map(nuevocliente => (nuevocliente.id === action.data.id ? action.data : nuevocliente)) }
        case GET_FILTROS_NUEVO_CLIENTE:
            return {
                ...state,
                filtros: action.filtros
            }
        default:
            return { ...state }
    }
}
export default nuevosclientes
